import PropTypes from "prop-types"
import * as AlertDialog from "@radix-ui/react-alert-dialog"
import { Button } from "../Button/Button"
import { cn } from "../../../lib/utils"

export default function AppAlertDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  onCancel,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "danger",
}) {
  const confirmButtonVariant =
    confirmVariant === "danger" ? "destructive" : confirmVariant

  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay
          className={cn(
            "fixed inset-0 z-[999] bg-black/45",
            "animate-overlay-in",
          )}
        />
        <AlertDialog.Content
          className={cn(
            "fixed left-1/2 top-1/2 z-[1000] -translate-x-1/2 -translate-y-1/2",
            "w-[calc(100%-32px)] max-w-[420px]",
            "max-h-[calc(100dvh-32px)] overflow-y-auto",
            "rounded-[8px] bg-[var(--surface-card,#fff)] p-6 shadow-[0_8px_32px_rgba(0,0,0,0.18)]",
            "animate-dialog-in",
          )}
        >
          <AlertDialog.Title className="mb-2 text-[16px] font-semibold text-[var(--text-heading,#1E293B)]">
            {title}
          </AlertDialog.Title>
          <AlertDialog.Description className="mb-5 text-[13px] leading-[1.5] text-[var(--text-secondary,#64748B)]">
            {description}
          </AlertDialog.Description>
          <div className="flex justify-end gap-2 max-sm:flex-col">
            <AlertDialog.Cancel asChild>
              <Button
                variant="outline"
                className="max-sm:w-full"
                onClick={onCancel}
              >
                {cancelLabel}
              </Button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <Button
                variant={confirmButtonVariant}
                className="max-sm:w-full"
                onClick={onConfirm}
              >
                {confirmLabel}
              </Button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}

AppAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmVariant: PropTypes.string,
}
